import { formatCurrency } from '../utilities/_commerce'

export const cartLineItem = ({
	id,
	url,
	image,
	onSale,
	price,
	salePrice,
	priceAsCurrency,
	subtotal,
	subtotalAsCurrency,
	qty,
	title,
	type,
	sku,
	purchasableId,
	discount = "0"
}) => ({
	id,
	type,
	url,
	image,
	onSale,
	price,
	salePrice,
	priceAsCurrency,
	subtotal,
	subtotalAsCurrency,
	qty,
	title,
	sku,
	purchasableId,
	savedQty: qty,
	discount,

	init() {
		this.$watch('qty', () => {
			this.updateCart()
		})

		// Because our store update() function emits a custom event with the line id and qty,
		// we can listen for this and update our local variables.
		// This is needed when there's two sets of cart line items, e.g. in the cart drawer
		// and on the cart page, and we want to keep them in sync when one is updated.
		//
		window.addEventListener('lineItemUpdated', (e) => {
			if (e.detail.id === this.id) {
				this.qty = e.detail.qty
			}
		})

		// Listen for cart updates and update line item.
		// This is needed because when the global cart is updated from other components e.g.
		// the addToCart component, the line item data in the cart drawer needs to be updated
		// to reflect the new cart data
		//
		window.addEventListener('cartUpdated', () => {
			this.$store.cart.lineItems.forEach(line => {
				if (line.id === this.id) {
					this.qty = line.qty
					this.price = line.price
					this.salePrice = line.salePrice
					this.subtotal = line.subtotal
					this.subtotalAsCurrency = line.subtotalAsCurrency
					this.discount = line.discount
				}
			})
		})
	},

	qtyDown() {
		if (this.qty > 1) {
			this.qty--
		}
	},

	getLineItemPrice(price, salePrice, qty) {
		if (salePrice) {
			return formatCurrency(salePrice * qty)
		} else {
			return formatCurrency(price * qty)
		}
	},

	qtyUp() {
		this.qty++
	},

	async removeItem() {
		this.$store.cart.remove(this.id)
	},

	async updateCart() {
		this.$store.cart.update(this.id, this.qty)
	},

	updateQtyFromStore() {
		this.$store.cart.lineItems.forEach(line => {
			if (line.id === this.id) {
				this.qty = line.qty
			}
		})
	}
})
